<template>
  <v-container v-if="!containerInitLoading && counter" fluid style="height: inherit">
    <v-row align="stretch" style="height: inherit;">
      <v-col style="max-width: 400px;">
        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="counter"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, editMode, handleFocus }">
            <CounterEditContent :item="item" :editMode="editMode" :handleFocus="handleFocus">
            </CounterEditContent>
          </template>
        </EntityEditCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";
import CounterEditContent from "@/views/admin/counters/CounterEditContent.vue";

export default {
  name: "ViewCounterInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    EntityEditCard,
    CounterEditContent,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      const dto = Object.assign({}, obj);
      await this.updateCounter(dto)
        .then((response) => {
          this.counter = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {
    counter: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

  },

  watch: {

  },
};
</script>


<style lang='scss'></style>